// Copyright 2015-2020 SWIM.AI inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {ViewScope, Viewport, UiViewContext, UiView} from "@swim/view";
import {Theme} from "@swim/theme";
import {AppViewController} from "./AppViewController";

export class AppView extends UiView {
  get viewController(): AppViewController | null {
    return this._viewController;
  }

  @ViewScope<AppView, Theme>({
    init: function (this: AppView): Theme {
      return this.createTheme();
    },
  })
  theme: ViewScope<this, Theme>;

  protected createTheme(): Theme {
    const colorScheme = this.viewport.colorScheme;
    if (colorScheme === "dark") {
      return Theme.dark;
    } else {
      return Theme.light;
    }
  }

  protected onResize(viewContext: UiViewContext): void {
    super.onResize(viewContext);
    this.updateViewIdiom(viewContext.viewport);
  }

  protected updateViewIdiom(viewport: Viewport) {
    if (viewport.width < 960 || viewport.height < 480) {
      this.setViewIdiom("mobile");
    } else {
      this.setViewIdiom("desktop");
    }
  }
}
